import { TooltipDesktop, Button } from '@cian/ui-kit';
import { IconToggleHeartOn16, IconToggleHeartOff16 } from '@cian/ui-kit-design-tokens/icons';
import { FC, MouseEvent } from 'react';

interface IFavoritesButtonProps {
  isFavorite: boolean;
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
}

export const FavoritesButton: FC<IFavoritesButtonProps> = ({ isFavorite, onClick }) => {
  return (
    <TooltipDesktop theme="black" placement="left" title={isFavorite ? 'В избранном' : 'Добавить в избранное'}>
      <Button
        data-name="FavoritesControl"
        size="XS"
        theme="stroke_secondary"
        onClick={onClick}
        beforeIcon={isFavorite ? <IconToggleHeartOn16 color="icon-negative-default" /> : <IconToggleHeartOff16 />}
      />
    </TooltipDesktop>
  );
};
